export default function titleCaseCompanyName(name = "") {
  return name
    .split(/(\s+|-)/)
    .map(part => {
      if (!part || part === "-" || /^\s+$/.test(part)) return part;

      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    })
    .join("");
}
